export default function({ state, commit, dispatch, rootGetters }, query) {
    let providerId = state.id
    if(state.providerPatients.length === 1)
        providerId = state.providerPatients[0].id
    if(!providerId)
        providerId = state.providerPatients
            .flatMap((provider) => provider.patient.map((patient) => ({id: patient.id, providerId: [provider.id]})))
            .find(({ id }) => id === query.id)
            .providerId

    return dispatch('get', {
        url: '/ctc/' + providerId + '/patient/' + query.id + '?questionnaire=true'
    }, {
        root: true
    })
    .then((response) => {
        console.log(response)
    })
}